import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppNotification, WebSocketNotificationService } from '../../../../services/websocket-notification.service';

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss', '../../../../../assets/styles/gestion-financiera.scss'],
  imports: [CommonModule]
})
export class NotificationModalComponent implements OnInit {
  protected wsService = inject(WebSocketNotificationService);
  protected notifications: AppNotification[] = [];

  private userId: string = '';

  constructor(
    public dialogRef: MatDialogRef<NotificationModalComponent>
  ) {}

  ngOnInit(): void {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.userId = String(currentUser?.usuId ?? currentUser?.id ?? '');
    this.wsService.notifications$.subscribe(n => (this.notifications = n));
  }

  onMarkRead(notif: AppNotification): void {
    if (!notif.read) {
      this.wsService.markAsRead(notif.messageId, this.userId);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
